module.exports = __webpack_public_path__ + "img/cpu-fill.8493035d.svg";